export const en = {
    'add-turbo': 'Add Turbo page',
    'different-turbo': 'Different Turbo pages',
    edit: 'Change',
    'edit-all': 'Edit all',
    turbo: 'Turbo page'
};
